// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMark40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMark40: FC<QuestionMark40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M17.861 26.389c.019-2.084.238-3.595.66-4.535.421-.94 1.247-1.965 2.479-3.076 1.157-1.037 2.044-1.98 2.66-2.827.616-.847.923-1.77.923-2.77 0-1.213-.405-2.223-1.215-3.028-.81-.806-1.942-1.209-3.396-1.209-1.435 0-2.535.417-3.298 1.25-.764.834-1.317 1.695-1.66 2.584l-3.764-1.64c.602-1.684 1.648-3.129 3.139-4.332C15.879 5.602 17.74 5 19.972 5c2.824 0 4.998.785 6.521 2.354 1.523 1.57 2.285 3.456 2.285 5.66 0 1.352-.29 2.553-.868 3.604-.579 1.051-1.498 2.183-2.757 3.396-1.361 1.305-2.183 2.303-2.465 2.993-.283.69-.433 1.817-.452 3.382h-4.375Zm2.111 10.278a2.943 2.943 0 0 1-2.16-.896 2.943 2.943 0 0 1-.895-2.16c0-.842.298-1.562.895-2.16a2.943 2.943 0 0 1 2.16-.895c.843 0 1.563.298 2.16.895.597.598.896 1.318.896 2.16 0 .843-.299 1.563-.896 2.16a2.944 2.944 0 0 1-2.16.896Z" />
        </svg>
    );
};

export default QuestionMark40;
